import {
  ListItemProps as MuiListItemProps,
  ListItemButtonProps as MuiListItemButtonProps,
  listItemClasses as muiListItemClasses,
  getListItemUtilityClass,
  listItemButtonClasses as muiListItemButtonClasses,
  getListItemButtonUtilityClass,
  ListItemIconProps as MuiListItemIconProps,
  listItemIconClasses as muiListItemIconClasses,
  getListItemIconUtilityClass,
} from '@mui/material';
import { AvatarSize } from '../avatar';

type CommonOmitProps = 'dense' | 'disableGutters' | 'disablePadding' | 'alignItems';

export const listItemClasses = {
  ...muiListItemClasses,
  withSecondaryAction: getListItemUtilityClass('withSecondaryAction'),
};

export type ListItemProps = Omit<
  MuiListItemProps,
   // NOTE: these are deprecated
  'button' | 'selected' | 'disabled' | 'autofocus' | 'ContainerComponent' | 'ContainerProps' |
  // NOTE: these we disallow
  CommonOmitProps
>;

interface ListItemButtonOwnProps {
  strong?: boolean;
}

export const listItemButtonClasses = {
  ...muiListItemButtonClasses,
  strong: getListItemButtonUtilityClass('strong'),
};

export type ListItemButtonProps = Omit<
  MuiListItemButtonProps<'div', ListItemButtonOwnProps>,
  CommonOmitProps | 'centerRipple' | 'disableRipple' | 'disableTouchRipple' | 'focusRipple'
  | 'TouchRippleProps' | 'touchRippleRef'
>;

export const listItemIconClasses = {
  ...muiListItemIconClasses,
  xs: getListItemIconUtilityClass('sx'),
  sm: getListItemIconUtilityClass('sm'),
  md: getListItemIconUtilityClass('md'),
  lg: getListItemIconUtilityClass('lg'),
  xl: getListItemIconUtilityClass('xl'),
};

export type ListItemIconProps = MuiListItemIconProps & {
  size?: AvatarSize,
};
